function ApiService($http, AppSettings, Upload) {
  'ngInject';

  const service = {};

  service.get = function (url, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'GET',
      dataType: 'json'
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.post = function (url, data, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'POST',
      datatype: 'json',
      data: data
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.patch = function (url, data, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'PATCH',
      datatype: 'json',
      data: data
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.delete = function (url, data, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'DELETE',
      dataType: 'json',
      data: data
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.put = function (url, data, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'PUT',
      dataType: 'json',
      data: data
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.saveFile = function (url, data, callbackFunc) {
    Upload.upload({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'POST',
      dataType: 'json',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.updateSaveFile = function (url, data, callbackFunc) {
    Upload.upload({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'PATCH',
      dataType: 'json',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(function (data) {
      callbackFunc(data);
    }).catch(function (data) {
      callbackFunc(data);
    });
  };

  service.resetPassword  = function(url, data, header, callbackFunc) {
    $http({
      url: `${AppSettings.apiUrl}${url}`,
      method: 'PATCH',
      datatype: 'json',
      headers: header,
      data: data
    }).then(function(data) {
      callbackFunc(data);
    }).catch(function(data){
      callbackFunc(data);
    });
  };

  return service;
}

export default {
  name: 'ApiService',
  fn: ApiService
};
